import type { BoxProps } from '@mui/material';
import type { AppRoute } from 'src/routes/types';

import { AppBar, Box, Toolbar } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';

// components
import { NavSectionHorizontal } from '../../../components/nav-section';
// config
import { HEADER } from '../../../config-global';
// utils
import { bgBlur } from '../../../utils/cssStyles';
//
import navConfig from './config-navigation';

type NavHorizontalProps = {
  privateAppRoutes: AppRoute[];
};

const NavHorizontal = ({ privateAppRoutes }: NavHorizontalProps) => {
  const theme = useTheme();

  return (
    <AppBar
      color="transparent"
      component="nav"
      sx={{
        boxShadow: 0,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal data={navConfig(privateAppRoutes)} />
      </Toolbar>

      <Shadow />
    </AppBar>
  );
};

export default memo(NavHorizontal);

const Shadow = ({ sx, ...other }: BoxProps) => {
  return (
    <Box
      sx={{
        borderRadius: '50%',
        bottom: 0,
        boxShadow: (theme) => theme.customShadows.z8,
        height: 24,
        left: 0,
        m: 'auto',
        position: 'absolute',
        right: 0,
        width: 1,
        zIndex: -1,
        ...sx,
      }}
      {...other}
    />
  );
};
